// @ts-strict-ignore
import { useDispatch, useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { fetchUserPosts } from 'src/modules/user/profile/actions';
import { PanelWrapperPost, PostsContainer } from 'src/modules/user/profile/components/shared/sharedStyles';
import NoPostsYetMessage from 'src/modules/user/profile/components/shared/noPostsMessage';
import FeedItemContainer from 'src/modules/shared/resultsListNew/components/feedItemContainer';
import PostItem from 'src/modules/shared/resultsListNew/components/postItem';
import { PostType } from 'src/constants/types';
import ShowMoreResults from 'src/modules/user/profile/components/shared/showMoreResults';
import Loader from 'src/components/loader';
export default function ProfilePosts(): JSX.Element {
  const dispatch = useDispatch();
  const {
    posts,
    profileUser,
    basics,
    isLoading
  } = useSelector(({
    pages
  }) => pages.profile);
  const clickMetadata = {
    section: Section.ProfilePosts,
    origin: profileUser.isOwnProfile ? 'own-profile' : 'other-profile'
  };
  const onShowMoreClick = () => {
    trackFootfallEvent(Event.Clicked, {
      clickType: 'show-more',
      clickMetadata
    });
    const createdBeforePostId = posts[posts?.length - 1].postId;
    dispatch(fetchUserPosts(profileUser.userId, PostType.Post, createdBeforePostId));
  };
  return <PanelWrapperPost data-testid="profile__posts_panel" data-sentry-element="PanelWrapperPost" data-sentry-component="ProfilePosts" data-sentry-source-file="profilePosts.tsx">
      {isLoading ? <Loader /> : !posts.length ? <NoPostsYetMessage /> : <PostsContainer>
                {posts.map(post => <FeedItemContainer clickMetadata={clickMetadata} communitySlug={post.community.slug} isPrivate={post.isPrivate} key={post.postId} postId={post.postId} postTypeId={post.postTypeId} title={post.title} urlEncodedTitle={post.urlEncodedTitle}>
                    <PostItem author={{
          username: profileUser.username,
          userImageHash: basics.userImageHash
        }} bodySnippet={post.bodySnippet} clickPostMetadata={clickMetadata} community={post.community} dateCreated={post.dateCreated} isLocked={post.isLocked} isPrivate={post.isPrivate} postId={post.postId} postImageHash={post.postImageHash} postTypeId={post.postTypeId} title={post.title} totalResponses={post.totalResponses} urlEncodedTitle={post.urlEncodedTitle} />
                  </FeedItemContainer>)}
                <ShowMoreResults items={posts} label={i18n.t('Show more posts')} onShowMore={onShowMoreClick} />
              </PostsContainer>}
    </PanelWrapperPost>;
}